module.exports = __webpack_public_path__ + "img/no-assessment.6d234338.png";